import { Component } from '@angular/core';

@Component({
  selector: 'app-rbi-disclaimer',
  templateUrl: './rbi-disclaimer.component.html',
  styleUrls: ['./rbi-disclaimer.component.css']
})
export class RbiDisclaimerComponent {}
